import React from 'react';
import WheelComponent from 'react-wheel-of-prizes'
// import 'react-wheel-of-prizes/dist/index.css'

const WheelOfWalt = () => {

    const segments = [
        'Treat yourself to a beer',
        'A tender hug from Eric',
        '3 minutes of unbroken eye contact with Joe',
        'Why not a beer',
        'All expenses paid vacation, expenses paid by you',
        'A free complement, to be given by Eric',
        'Phone call with Joe where we can dish hot gossip',
        'A firm handshake'
    ]
    const segColors = [
        '#EE4040',
        '#F0CF50',
        '#815CD1',
        '#3DA5E0',
        '#34A24F',
        '#F9AA1F',
        '#EC3F3F',
        '#FF9000'
    ]
    const onFinished = (winner) => {
        console.log(winner)
    }
    return (
        <WheelComponent
            segments={segments}
            segColors={segColors}
            winningSegment='won 10'
            onFinished={(winner) => onFinished(winner)}
            primaryColor='black'
            contrastColor='white'
            buttonText='Spin'
            isOnlyOnce={false}
            size={295}
            upDuration={100}
            downDuration={1000}
            fontFamily='Arial'
        />
    )

}

export default WheelOfWalt